export default __webpack_public_path__ + "static/digital-attendance-assesment-custom-LMS-847c4cfcb642e0deee366c41779a2d28.jpg";